"use strict";
/*jshint esversion: 11 */

import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import PivotalApiEnvironments
  from "../../../js/csf/pivotal/PivotalApiEnvironments";

class CsfMembreDispensesDataLayer {

  static getFollowupTypes() {
    return {
      APPROUVEE: 'AAAAAAAAAu4=',
      PIECES_JUSTIFICATIVES_DEMANDEES: 'AAAAAAAAAxA=',
      PRE_APPROUVEE: 'kAAAAAAAAAA=',
      RECUE_A_TRAITER: 'AAAAAAAAAw4=',
      REJETEE: 'AAAAAAAAAu0=',
      TRAITEMENT_EN_COURS: 'AAAAAAAAAw8=',
    };
  }

  constructor(apiUrl, apiEnv, accessToken, fnApiCallbackError) {
    this.accessToken = accessToken;
    this.apiUrl = apiUrl;
    this.apiEnv = apiEnv;
    this.isInit = true;
    this.apiErrorCallback = fnApiCallbackError;
  }

  static isEditableDispense(followupTypeId) {
    return followupTypeId !== FOLLOWUP_TYPES.APPROUVEE && followupTypeId !== FOLLOWUP_TYPES.PRE_APPROUVEE;
  }

  static isDeletableDispense(followupTypeId) {
    return followupTypeId !== FOLLOWUP_TYPES.APPROUVEE && followupTypeId !== FOLLOWUP_TYPES.PRE_APPROUVEE;
  }

  fetchMemberContactInfo(contactId, setMemberContactInfoCallback) {

    const requestData = {
      form: 'CSF_EM_Contact_Info',
      recordId: contactId
    };
    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setMemberContactInfoCallback(response.payload.data.primary);
        } else {
          this.apiErrorCallback("Error in fetchMemberContactInfo");
        }
      })
      .catch(error => {
        this.apiErrorCallback(error);
      });
  }


  // Obtain lists of exemptions (dispenses) from Pivotal API
  fetchExemptions(reduEducationFileId, setExemptionsCallback) {
    const requestData = {
      form: 'CSF_EM_Exemption_Info',
      recordId: reduEducationFileId
    };
    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.Exemption__Secondary) {
          setExemptionsCallback(response.payload.data.primary.Exemption__Secondary);
        } else {
          this.apiErrorCallback("Error in fetchExemptions");
        }
      })
      .catch(error => {
        console.error(error);
        this.apiErrorCallback(error);
      });
  }

  submitDispenseData(recordId, formData, submitSuccessCallback, submitErrorCallback) {
    let requestData = {
      form: 'CSF_EM_Exemption_REST',
      recordId: recordId,
      deltaData: formData
    };

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success) {
          submitSuccessCallback();
        } else {
          submitErrorCallback();
        }
      })
      .catch(error => {
        submitErrorCallback();
      });
  }


  deleteDispense(dispenseId, submitSuccessCallback, submitErrorCallback) {
    let requestData = {
      form: 'CSF_EM_Exemption_DELETE',
      recordId: dispenseId
    };

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormDeleteEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success) {
          submitSuccessCallback();
        } else {
          submitErrorCallback();
        }
      })
      .catch(error => {
        submitErrorCallback();
      });
  }

  static getReasonCodes() {
    return {
      MATERNITE: 0,
      MALADIE: 1,
      MALADIE_INDETERMINEE: 2,
      INVALIDITE_PERMANENTE: 3,
      PATERNITE: 4,
      ADOPTION: 5,
      AIDANT_NATUREL: 6
    };
  }

  static getReasonDescriptionFromCode(reasonCode) {
    // declare array to force Drupal to output translations to js:
    const reasons = [
      window.Drupal.t('membre.dispense.reason_0_description'),
      window.Drupal.t('membre.dispense.reason_1_description'),
      window.Drupal.t('membre.dispense.reason_2_description'),
      window.Drupal.t('membre.dispense.reason_3_description'),
      window.Drupal.t('membre.dispense.reason_4_description'),
      window.Drupal.t('membre.dispense.reason_5_description'),
      window.Drupal.t('membre.dispense.reason_6_description'),
    ];

    return reasons[reasonCode];
  }

  static getDispenseStatusCssClasses(followupTypeId) {
    if (followupTypeId === FOLLOWUP_TYPES.APPROUVEE || followupTypeId === FOLLOWUP_TYPES.PRE_APPROUVEE) {
      // acceptée
      return 'espaces__tag espaces__tag--slim mr-1';
    }
    else if (followupTypeId === FOLLOWUP_TYPES.REJETEE) {
      // refusée
      return 'espaces__tag espaces__tag--error espaces__tag--sli mr-1m';
    }
    else if (followupTypeId === FOLLOWUP_TYPES.PIECES_JUSTIFICATIVES_DEMANDEES || followupTypeId === FOLLOWUP_TYPES.RECUE_A_TRAITER || followupTypeId === FOLLOWUP_TYPES.TRAITEMENT_EN_COURS) {
      // en traitement
      return 'espaces__tag espaces__tag--gray espaces__tag--slim mr-1';
    }
    else {
      return '';
    }
  }

  static getFormattedDispenseDate(dateString) {
    if (dateString == null || dateString === '') {
      return '';
    }

    const date = new Date(dateString);

    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    };

    // Format date as dd/mm/yyyy
    let formattedDate = new Intl.DateTimeFormat("en-GB", options).format(date);
    // Replace '-' with '/'  for final format: dd/mm/yyyy
    return formattedDate.replaceAll('-', '/');
  }

}

export default CsfMembreDispensesDataLayer;

export const FOLLOWUP_TYPES = CsfMembreDispensesDataLayer.getFollowupTypes();
export const DISPENSES_REASON_CODES = CsfMembreDispensesDataLayer.getReasonCodes();
